import * as React from 'react';
import { Form, Pagination, PaginationProps, ButtonProps } from 'semantic-ui-react';

interface IntroState {
  currentStep: number;
}

class Intro extends React.Component<{}, IntroState> {
  constructor(props:any) {
    super(props);

    this.state = {currentStep: 1}
  }

  public render() {
    return (
      <div className='application-form-wrap'>
      <h6>SECTION 1 - STEP {this.state.currentStep}</h6>
      <h1>INTRODUCTION</h1>
      <Form>
        
       {/* Step 1 */ }
       { this.state.currentStep === 1 &&
      <div className='card'>
        <p>
          Bermuda is one of more than 100 jurisdictions that has indicated it will implement the Common Reporting Standards (CRS) framework developed by the Organization for Economic Co-operation and Development (OECD) and has agreed to begin reporting in 2017. As a Bermuda entity, it is anticipated that Sanlam will be required to disclose certain information, including an investor’s name, address, tax number, account number(s) and the balance or value of the account(s) and beneficial owner(s) to the local tax authority. The local tax authority may share this information with the applicable tax office of any jurisdiction with which it has an international agreement in place.
        </p>
        <p>
          As you were previously notified, for all applications submitted in 2017, the submission of the applicable CRS Self- Certification form(s) is required. This submission will be a good order requirement in order for an application to be accepted.
        </p>
  
        <h4>WHAT IS REQUIRED</h4>
        
        <p>
          For Individual Plan holders
          a Self Certification for Individuals form must be completed by each individual applicant. This means for applications that designate two or more plan holders, a Self-Certification for Individuals form needs to be completed and submitted by each proposed plan holder.
        </p>
        <p>
          Each Self-Certification form contains instructions and definitions of applicable terms. These forms can be found on the website, under Application and Admin Forms tab.
          If an investor is not sure how to complete the applicable Self-Certification forms, we suggest that independent tax advice is obtained to help decide as the information provided may have an effect on an investor’s tax requirements in certain jurisdictions. The information provided will be reviewed and if further information is required, we will contact you.
          If you have any questions about the above, please contact your Relationship Manager.
          If you have any questions regarding CRS, you should consult a tax advisor for independent tax advice.
        </p>
        <Form.Button onClick={this.next}>Next</Form.Button>
              
      </div>
       }
      {/* Step 2 */ }
      { this.state.currentStep === 2 &&
      <div className='card'>
        <p>
            The person(s) designated as the Plan holder (hereinafter collectively the “Plan holder”) hereby authorises Sanlam Global Investment Solutions, Ltd., a Bermuda company registered under the Segregated Accounts Company Act 2000 (as amended), in respect of a segregated account (“Sanlam Global”), to procure the investment of the Plan holder’s money so that the Plan holder will have investment exposure to underlying investments (“Investment Options”) in international funds (“Funds”) through the Sanlam Global Investment Plan.
        </p>
        <h4>DOCUMENTATION REQUIREMENTS FOR APPLICATIONS BY INDIVIDUAL PLAN HOLDER IN ALL CASES</h4>    
          <ul className='ui list'>
            <li>Proof of identity/passport</li>
            <li>Proof of physical residential address</li>
            <li>Proof of source of funds</li>
            <li>Wire Transmittal Form</li>
            <li>Signed investment options booklet</li>
            <li>Signed Charges Sheet</li>
            <li>Proof of identity - e.g. current passport or other government issued identification document containing a photo and date of birth.</li>
            <li>Proof of physical address – e.g. utility bill not older than 6 months.</li>
            <li>Should an investment be made on behalf of a minor, proof of identity and physical address of the authorised adult as well as the minor’s birth certificate or passport will be required.</li>
          </ul>
  
        <Form.Button onClick={this.handlePageChange}>I'VE READ IT AND UNDERSTAND</Form.Button>
  
      </div>
      }
      <Pagination
        className='application-form-pagination'
        activePage={this.state.currentStep}
        onPageChange={this.handlePaginationChange}
        totalPages={2}
        firstItem={null}
        lastItem={null}
        prevItem={null}
        nextItem={null}
      />
      </Form>
    </div>
    
    );
  }
  
  private next = () => this.setState({ currentStep: this.state.currentStep + 1});

  private handlePageChange = (event: React.FormEvent<HTMLButtonElement>, button: ButtonProps) => {
    event.preventDefault();

    // TODO => Page Change
  }

  private handlePaginationChange = (event: React.MouseEvent<HTMLAnchorElement>, pagination: PaginationProps) => {
    this.setState({currentStep: pagination.activePage as number});
  }
}

export default Intro;